export default "__VITE_ASSET__n_FyVSIr__"